/* eslint-disable sciencepo-rules/require-story*/
/* Inutile de le tester*/
import * as mainStyles from '../../../styles/layout/main.module.scss';
import FilAriane from '../../page_structure/FilAriane';
import React from 'react';
import PropTypes from 'prop-types';

const EventLayout = ({children, ...props}) => {

  let displayLang = '';
  if (props && props.lang) {
    displayLang = props.lang.toLowerCase();
  }

  return (
    <div className={mainStyles.centerMaxSize}>
      <div className={mainStyles.innerTemplate}
        id="main-content-page"
      >
        <div className={mainStyles.eventTemplateFilAriane}>
          <FilAriane ariane={props.filAriane}
            lang={displayLang}
            url={props.url}
          >
          </FilAriane>
        </div>
        {children}
      </div>
    </div>
  );
};

EventLayout.propTypes = {
  children: PropTypes.node,
  filAriane: PropTypes.array.isRequired,
  lang: PropTypes.string,
  url: PropTypes.string,
};

export default EventLayout;
